import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { createClient } from 'graphql-ws'
import { execute } from '@apollo/client/link/core'
import { NotificationStore } from '@/components/vueblack/NotificationPlugin'

let activeSocket = null
let timedOut = null

const wsLink = new GraphQLWsLink(
  createClient({
    url: process.env.NUXT_ENV_WS_ORDER_URI,
    keepAlive: 10000,
    retryAttempts: Infinity,
    shouldRetry: () => true,
    connectionParams: {
      authToken: process.env.NUXT_ENV_PUBSUB_TOKEN_SECRET
    },
    on: {
      connected: socket => {
        activeSocket = socket
        console.log('Subscription Pub/Sub Order Connected 🔌🙌')
      },
      ping: received => {
        // console.log('ping :>> ', received)
        if (!received)
          timedOut = setTimeout(() => {
            if (activeSocket.readyState === WebSocket.OPEN) {
              activeSocket.close(4408, 'Request Timeout')
            }
          }, 5000) // wait 5 seconds for the pong and then close the connection
      },
      pong: received => {
        console.log('pong order', received)
        if (received) clearTimeout(timedOut) // pong is received, clear connection close timeout
      },
      closed: () => {
        console.log('CONNECTION CLOSED')
      },
      error: err => {
        console.error('Connection error 👾', err)
        // NotificationStore.notify({
        //   type: 'danger',
        //   message: 'Error indefinido en la Suscripción.',
        //   icon: 'fa fa-cloud-showers-heavy'
        // })
      }
    }
  })
)

export const runSubscription = (operator, fn) => {
  execute(wsLink, operator).subscribe({
    next: data => {
      console.log('data :>> ', data)
      if (data.errors) {
        NotificationStore.notify(errorsToArray(data))
        return fn(data.errors)
      }
      return fn(null, data)
    }
  })
}

const errorsToArray = data =>
  data.errors.reduce((arr, item) => {
    arr.push({
      type: 'danger',
      message: item.message || 'Error general de la aplicación :(',
      icon: 'fa fa-cloud-showers-heavy'
    })

    return arr
  }, [])
